import { commentItems } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-cinema-surface">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">读者评论</h2>
          <p className="text-sm text-cinema-muted">真实用户反馈 · 来自千万影迷的声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {commentItems.map((item, i) => (
            <div
              key={i}
              className="bg-cinema-card border border-cinema-border rounded-xl p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-cinema-gold/20 flex items-center justify-center text-cinema-gold font-bold text-sm">
                  {item.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-semibold text-white whitespace-nowrap">{item.name}</div>
                  <div className="text-xs text-cinema-muted">{item.time}</div>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, j) => (
                  <div key={j} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className={`text-xs ${j < item.rating ? 'ri-star-fill text-cinema-gold' : 'ri-star-fill text-cinema-border'}`}></i>
                  </div>
                ))}
              </div>
              <p className="text-sm text-cinema-text-dim leading-relaxed mb-4">{item.content}</p>
              <div className="flex items-center gap-1 text-xs text-cinema-muted">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{item.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}